import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useFilmOtt } from './use-film-ott';

export const useFilmCurrentStream = (contentId: string) => {
    const filmOtt = useFilmOtt(contentId);

    return useCurrentStream(filmOtt?.onlineStreams?.streams);
};
